import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { i18n } from '../index';
function updateMetaTag(name, content, isProperty) {
    const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
    let tag = document.querySelector(selector);
    if (!tag) {
        tag = document.createElement('meta');
        if (isProperty) {
            tag.setAttribute('property', name);
        }
        else {
            tag.setAttribute('name', name);
        }
        document.head.appendChild(tag);
    }
    tag.content = content;
}
export const useHtmlLangSync = (metaConfig) => {
    const { t: tr } = useTranslation(metaConfig?.namespace);
    useEffect(() => {
        const sync = () => {
            document.documentElement.lang = i18n.language;
            if (metaConfig) {
                document.title = tr(metaConfig.titleKey);
                updateMetaTag('description', tr(metaConfig.descriptionKey));
                if (metaConfig.keywordsKey) {
                    updateMetaTag('keywords', tr(metaConfig.keywordsKey));
                }
                if (metaConfig.authorKey) {
                    updateMetaTag('author', tr(metaConfig.authorKey));
                }
                if (metaConfig.robotsKey) {
                    updateMetaTag('robots', tr(metaConfig.robotsKey));
                }
                if (metaConfig.ogTitleKey) {
                    updateMetaTag('og:title', tr(metaConfig.ogTitleKey), true);
                }
                if (metaConfig.ogDescriptionKey) {
                    updateMetaTag('og:description', tr(metaConfig.ogDescriptionKey), true);
                }
                if (metaConfig.ogSiteNameKey) {
                    updateMetaTag('og:site_name', tr(metaConfig.ogSiteNameKey), true);
                }
                if (metaConfig.ogTypeKey) {
                    updateMetaTag('og:type', tr(metaConfig.ogTypeKey), true);
                }
                if (metaConfig.ogLocaleKey) {
                    updateMetaTag('og:locale', tr(metaConfig.ogLocaleKey), true);
                }
                if (metaConfig.ogImageUrl) {
                    updateMetaTag('og:image', metaConfig.ogImageUrl, true);
                }
            }
        };
        sync();
        i18n.on('languageChanged', sync);
        return () => {
            i18n.off('languageChanged', sync);
        };
    }, [tr, metaConfig]);
};
